"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
    if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  }
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};

var __metadata = this && this.__metadata || function (k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};

var __param = this && this.__param || function (paramIndex, decorator) {
  return function (target, key) {
    decorator(target, key, paramIndex);
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var typescript_ioc_1 = require("@logio/typescript-ioc");

var EntityStateFlag_1 = require("../../core/model/EntityStateFlag");

var ProductPurchasePrice_1 = require("../model/ProductPurchasePrice");

var PriceWithVatConverter_1 = require("./PriceWithVatConverter");

var ProductPurchasePriceConverter_1 = require("./ProductPurchasePriceConverter");
/**
 * Implementation of {@link ProductPurchasePriceConverter}
 *
 * @author JMe
 */


var ProductPurchasePriceConverterImpl =
/*#__PURE__*/
function (_ProductPurchasePrice) {
  _inherits(ProductPurchasePriceConverterImpl, _ProductPurchasePrice);

  function ProductPurchasePriceConverterImpl(priceWithVatConverter) {
    var _this;

    _classCallCheck(this, ProductPurchasePriceConverterImpl);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(ProductPurchasePriceConverterImpl).call(this));
    _this.priceWithVatConverter = priceWithVatConverter;
    return _this;
  }
  /**
   * @inheritDoc
   */


  _createClass(ProductPurchasePriceConverterImpl, [{
    key: "toDocument",
    value: function toDocument(source, conversions) {
      if (typeof source !== 'object' || source === null) {
        return null;
      }

      var result = {};
      Object.assign(result, conversions.classToDocumentId(source));
      Object.assign(result, {
        productId: conversions.toDocumentReferenceId(source.productId),
        categoryIds: conversions.asObjectArray(source, 'categoryIds', function (id) {
          return conversions.toDocumentReferenceId(id);
        }),
        stateFlags: source.stateFlags.serialize(),
        avgPrice: source.avgPrice != null ? this.priceWithVatConverter.toDocument(source.avgPrice, conversions) : null,
        priceListPrice: source.priceListPrice != null ? this.priceWithVatConverter.toDocument(source.priceListPrice, conversions) : null
      });
      return result;
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "toObject",
    value: function toObject(source, conversions) {
      var _this2 = this;

      return new ProductPurchasePrice_1.ProductPurchasePrice(ProductPurchasePrice_1.ProductPurchasePrice.schema.id.valueOf(conversions.documentToClassId(source)), ProductPurchasePrice_1.ProductPurchasePrice.schema.productId.valueOf(conversions.toClassReferenceId(source.productId)), ProductPurchasePrice_1.ProductPurchasePrice.schema.categoryIds.valueOf(conversions.asClassReferenceIdsList(source, 'categoryIds')), conversions.asFlagSet(source.stateFlags, EntityStateFlag_1.EntityStateFlag), conversions.asObjectOpt(source, 'avgPrice', function (doc) {
        return _this2.priceWithVatConverter.toObject(doc, conversions);
      }), conversions.asObjectOpt(source, 'priceListPrice', function (doc) {
        return _this2.priceWithVatConverter.toObject(doc, conversions);
      }));
    }
  }]);

  return ProductPurchasePriceConverterImpl;
}(ProductPurchasePriceConverter_1.ProductPurchasePriceConverter);

ProductPurchasePriceConverterImpl = __decorate([__param(0, typescript_ioc_1.Inject), __metadata("design:paramtypes", [PriceWithVatConverter_1.PriceWithVatConverter])], ProductPurchasePriceConverterImpl);
exports.ProductPurchasePriceConverterImpl = ProductPurchasePriceConverterImpl;